export default __webpack_public_path__ + "static/media/img-sad-light.07208c3e.svg";